/* ---------------------------------------------------------------------------------------
* about:遥控类的方法
* author:马兆铿
* date:2018-8-16
* ---------------------------------------------------------------------------------------- */
import {supportConnectDevice} from "../deviceConnect";

//酷控的设备类型号
export const kookongDeviceType = {
  TV: 2,
  TV_BOX: 1,
  AIR: 5,
  FAN: 8,
};

//后台要求的，遥控类的company参数的值的构造的对象
export class RemoteParams {
  constructor() {
    this.spType = 0;
    this.spId = 0;
    this.areaId = 0;
    this.brandId = 0;
    this.countryCode = 'CN'; // 默认都是中国
  }

  /**
   * 转换成后台需要的company字段的字符串，有特定顺序
   * @return {string}
   */
  transToString() {
    return `${this.spType || 0},${this.spId || 0},${this.areaId || 0},${this.brandId || 0},${this.countryCode}`;
  }
}

/*  根据名字找到相对应的酷控类型
*@param {str}name设备名字
* */
export const getKooKongDeviceTypeByName = (name) => {
  return supportConnectDevice.find(item => item.name === name).kookongDeviceType || '';
};


// WEBPACK FOOTER //
// ./src/utils/device/set/remote.js